import { render, staticRenderFns } from "./ServiceCenter.vue?vue&type=template&id=dae1afa2&"
import script from "./ServiceCenter.vue?vue&type=script&lang=js&"
export * from "./ServiceCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports